export default "{{$ctrl.date_formatted}}";